<template>
  <div>
    <v-row class="pt-6" v-if="languguageSkills && languguageSkills.length">
      <v-col lg="6" cols="12" v-for="(item, index) in languguageSkills" :key="'row_' + index">
        <LanguageSkillItem :language="item" :isHiringmanager="isHiringmanager" :loading="loading" @edit="edit(item)" @remove="remove(item)" />
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import { LanguageSkill } from "../../../models/Teammember";
import Utils from "../../../utils/Utils";
import { defineComponent } from "vue";
import LanguageSkillItem from "./LanguageSkillItem.vue";

export default defineComponent({
  props: ["languageSkillList", "addLoading", "isHiringmanager"],
  components: { LanguageSkillItem },
  data() {
    return {
      languguageSkills: [] as LanguageSkill[],
      loading: false,
    };
  },
  methods: {
    edit(item: any) {
      this.$emit("edit", item);
    },
    remove(item: any) {
      this.$emit("remove", item);
    },
    formatDate(value: any): string {
      return `${Utils.toVsDateFormat(value)}`;
    },
  },
  watch: {
    addLoading(newVal) {
      this.loading = newVal;
    },
    languageSkillList(newVal) {
      this.languguageSkills = newVal;
    },
  },

  mounted() {
    this.languguageSkills = [...this.languageSkillList];
  },
});
</script>
